<template>
    <div class="tab-pane fade show active text-center" v-if="!is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="tab-pane fade show active text-center" v-else-if="teams.length == 0">
        <p>No team data found.</p>
        <!--      footer text-->
        <div class="note-text text-center py-10">
            <p>
                Planet Cricket Brings You Exclusive Coverage of Your Favorite (Legends League Cricket 2022/23 Teams), Latest News, Player Updates, Rumors and Injury News. Keep Watching the Latest from Your Team of (Legends League Cricket 2022/23 Teams) with Planet Cricket.
            </p>
        </div>
    </div>
    <div class="tab-pane fade show active" v-else>
        <strong class="h2 text-uppercase">teams ({{ teams.length }})</strong>
        <div class="row card-play-holder">
            <div class="col-sm-6 card-play" v-for="team in teams" :key="team.id">
                <router-link :to="{ name: 'teamDetail.Matches', params: { tournament: $route.params.tournament, team: team.slug } }">
                    <div class="icon-logo"><img width="42" height="42" class="lazyload" :src="team.flag.resizeImage(42,42)" alt="logo" /></div>
                    <div class="info">
                        <strong class="title">{{ team.name }}</strong>
                        <span class="sub-title">{{ global.Components['tournamentDetail'].tournament.name }}</span>
                    </div>
                </router-link>
            </div>
        </div>
        <!--      footer text-->
        <div class="note-text text-center py-10">
            <p>
                Planet Cricket Brings You Exclusive Coverage of Your Favorite (Legends League Cricket 2022/23 Teams), Latest News, Player Updates, Rumors and Injury News. Keep Watching the Latest from Your Team of (Legends League Cricket 2022/23 Teams) with Planet Cricket.
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'tournamentTeams',

        data() {
            return {
                teams: [],
            }
        },

        jsonld() {

            if (isServer)
                return {
                    "@context": "http://schema.org",
                    "@graph": []
                }

            if (!this.is_data_ready)
                return

                let standings = []
                this.teams.forEach((standing) => {
                standings.push(
                        {
                            "@type": "SportsTeam",
                            "name": standing.name,
                            logo: standing.flag,
                            "location": {
                            "@type": "Place",
                            "name": standing.name + ", " + standing.country,
                            "address": {
                            "@type": "PostalAddress",
                            "name": standing.name + ", " + standing.country,
                            }
                }
                        }
                )
            });
                return {
                "@context": "http://schema.org",
                "@graph": standings
            }
        },

        metaInfo() {
            if (!Components['tournamentDetail'])
                return
            let title = `${Components['tournamentDetail'].tournament.name} Team Score, Matches Schedule, Point Table, Fixture - Planet Cricket`;
            let description = `Get the latest cricket team's news matches, scores, and updates, videos, results, transfers from ${Components['tournamentDetail'].tournament.name} matches at Planet Cricket`;
            return {
                title: title,
                meta: this.$getMetaTags(title, description),
                link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
            }

        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main()
            }
        },
        mounted() {
            this.main()
        },

        methods: {
            main() {
                return this.$axios
                        .get(this.$TOURNAMENT_TEAMS_API.replace(':tournament', this.$route.params.tournament))
                        .then(response => {
                            this.is_data_ready = true
                            this.teams = response.data.result.teams || []
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },
        }
    }
</script>
